import { render } from "./CategoryHeader.vue?vue&type=template&id=59907be6"
import script from "./CategoryHeader.vue?vue&type=script&lang=js"
export * from "./CategoryHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__